<template>
  <el-row type="flex" justify="space-between">
    <el-col :span="12" class="list form-list mr-r20">
      <el-form ref="form" label-position="left">
        <el-form-item label="장비명" label-width="120px">{{ getValueAfterNullCheck(objInfo.objName) }}</el-form-item>
        <el-form-item label="IP" label-width="120px">{{ getValueAfterNullCheck(objInfo.ipaddress) }}</el-form-item>
        <el-form-item label="구동 시간" label-width="120px">{{ getValueAfterNullCheck(objInfo.netdeviceUptimeLabel) }}</el-form-item>
        <el-form-item label="관리자(정)" label-width="120px">{{ getValueAfterNullCheck(objInfo.majorLabel )}}</el-form-item>
      </el-form>
    </el-col>
    <el-col :span="12" class="list form-list">
      <el-form ref="form" label-position="left">
        <el-form-item label="장비 종류" label-width="120px">{{ getValueAfterNullCheck(objInfo.objtypeName) }}</el-form-item>
        <el-form-item label="제조사" label-width="120px">{{ getValueAfterNullCheck(objInfo.objCompanyName) }}</el-form-item>
        <el-form-item label="모델" label-width="120px">{{ getValueAfterNullCheck(objInfo.objProductId) }}</el-form-item>
        <el-form-item label="관리자(부)" label-width="120px">{{ getValueAfterNullCheck(objInfo.minorLabel) }}</el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import isNil from 'lodash/isEmpty';
import { EMPTY_TEXT } from '@/utils/string';

export default {
  name: 'WNetdeviceObjInfo',
  props: {
    objInfo: {
      type: Object,
    },
  },
  methods: {
    getValueAfterNullCheck(value) {
      return !isNil(value) ? value : EMPTY_TEXT;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/components/NetdeviceObjInfo.vue